"use strict";
/**
 *  Module
 *
 * Description
 */
angular.module('productAppDistributeAddModule', []).controller('appDistributeAddCtrl', ["$scope", "$modalInstance", "$q", "$validation", "modalDialog", "trsHttpService", "item", "siteid",
    function($scope, $modalInstance, $q, $validation, modalDialog, trsHttpService, item, siteid) {
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        initstatus();

        function initstatus() {
            $scope.productWebsite = [
                /*{
                            name: "文件系统",
                            value: "FILE"
                        }, */
                {
                    name: "SFTP服务",
                    value: "SFTP"
                }, {
                    name: "FTP服务",
                    value: "FTP"
                }
            ];
            $scope.list = {};
            $scope.hasPassive = false; //是否有‘使用被动模式’选项(FTP选择的时候有)
            $scope.list.PASSIVEMODE = 0;
            if (item === "") {
                /*$scope.list.TARGETTYPE = "FILE";*/
                $scope.list.TARGETTYPE = "SFTP";
                /*$scope.list.ENABLED = 0;*/
                $scope.list.ENABLEDFORAPP = 1;
                $scope.initProductWebsite = $scope.productWebsite[0];
            } else {
                var params = {
                    "serviceid": "mlf_websiteconfig",
                    "methodname": "getPublishDistribution",
                    "PUBLISHDISTRIBUTIONID": item.PUBLISHDISTRIBUTIONID
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.itemobj = data;
                    $scope.list = angular.copy($scope.itemobj);
                    $scope.initProductWebsiteOBJ = {};
                    $scope.initProductWebsiteOBJ.name = item.TARGETTYPENAME;
                    $scope.initProductWebsite = $scope.initProductWebsiteOBJ;
                    if ($scope.list.TARGETTYPE == 'FTP') {
                        $scope.hasPassive = true;
                    }
                });
            }
        }
        $scope.queryByDocStatus = function(item) {
            $scope.list.TARGETTYPE = item.value;
             if (item.value == 'FTP') {
                $scope.hasPassive = true;
            } else {
                $scope.hasPassive = false;
            }
            /*if (item.value == "FILE") {
                $scope.list={};
                $scope.list.TARGETTYPE = "FILE";
                $scope.initProductWebsite = $scope.productWebsite[0];
            }*/

        };
        $scope.selectDoc = function(params) {
            eval(params);
        };

        /*$scope.isConfirm = function() {
            var productWebsiteObj = {
                "TARGETSERVER": $scope.list.TARGETSERVER,
                "TARGETTYPE": $scope.list.TARGETTYPE,
                "TARGETPORT": $scope.list.TARGETPORT,
                "DATAPATH": $scope.list.DATAPATH,
                "LOGINUSER": $scope.list.LOGINUSER,
                "LOGINPASSWORD": $scope.list.LOGINPASSWORD,
                "PublishDistributionId": item.PUBLISHDISTRIBUTIONID,
                "ENABLEDFORAPP": $scope.list.ENABLEDFORAPP == 1 ? "true" : "false",
            };
            $modalInstance.close(productWebsiteObj);
        };*/
        $scope.isConfirm = function() {
            $validation.validate($scope.urlForm).success(function() {
                saveDistribute().then(function(data) {
                    modalDialog.alertType('保存成功', "", "success", false, function() {
                        $modalInstance.close(data);
                    });
                });
            }).error(function() {
                modalDialog.alertType('保存失败', "请检查填写项", "warning", false);
            });
        };

        function saveDistribute() {
            var defer = $q.defer();
            var productWebsiteObj = {
                "PublishDistributionId": item ? item.PUBLISHDISTRIBUTIONID : undefined,
                "serviceid": "mlf_websiteconfig",
                "methodname": "savePublishDistribution",
                "FOLDERID": siteid,
                "TARGETSERVER": $scope.list.TARGETSERVER,
                "TARGETTYPE": $scope.list.TARGETTYPE,
                "TARGETPORT": $scope.list.TARGETPORT,
                "DATAPATH": $scope.list.DATAPATH,
                "LOGINUSER": $scope.list.LOGINUSER,
                "LOGINPASSWORD": $scope.list.LOGINPASSWORD,
                "ENABLEDFORAPP": $scope.list.ENABLEDFORAPP == 1 ? "true" : "false",
                "PASSIVEMODE": $scope.list.PASSIVEMODE = $scope.initProductWebsite.name == "FTP服务" ? $scope.list.PASSIVEMODE : undefined
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), productWebsiteObj, "post").then(function(data) {
                //data = data.replace(/\"/g, "")
                defer.resolve(data);
            });
            return defer.promise;
        }
    }
]);